import React from "react";
import { useLocation } from "react-router-dom";
import "../css/Topbar.css";

export default function Topbar() {
  const location = useLocation();

  // Check if current page is Washing Machine Service
  const isWashingMachinePage = location.pathname === "/washing-machine-service";

  // Dynamic configurations based on current route
  const currentPhoneNumber = isWashingMachinePage ? "73175 96984" : "72378 98275";
  const rawPhoneNumber = isWashingMachinePage ? "7317596984" : "7237898275";

  return (
    <div
      id="topbar"
      className="topbar"
      role="banner"
      aria-label="Top bar"
    >
      <div className="topbar-container">
        {/* Left side - Working Time (hidden on small screens) */}
        <div className="topbar-section topbar-left" aria-hidden="false">
          <span className="topbar-label">Working Time</span>
          <span className="topbar-time">7 AM to 10 PM</span>
        </div>

        {/* Center - Urgent Service (always present; styled differently on mobile) */}
        <div className="topbar-section topbar-center">
          <span className="urgent-text">Need urgent service? </span>
          <a
            href={`tel:${rawPhoneNumber}`}
            className="topbar-phone"
            aria-label={`Call ${currentPhoneNumber}`}
          >
            {currentPhoneNumber}
          </a>
        </div>

        {/* Right side intentionally blank (hidden on small screens) */}
        <div className="topbar-section topbar-right" aria-hidden="false" />
      </div>
    </div>
  );
}